export const gridUnit = 4;
export const xSmallBorderRadius = '1px';
export const smallBorderRadius = '2px';
export const standardBorderRadius = '15px';
export const circleBorderRadius = '50%';
export const sideGutterAmount = gridUnit * 6;
export const sideGutter = `${sideGutterAmount}px`;
export const headerHeight = '65px';
